export default `
  query getPageBuilderPreview($token: String) {
    pageBuilderPreview(token: $token) {
        content
    }
  }
`;
